<div class="stepper" [ngClass]="config.orientation || 'horizontal'">
  <div class="stepper-header custom-scrollbar">
    @for (step of steps; track step; let i = $index) {
      <div class="step" [class.active]="i === activeStepIndex"
        [class.completed]="i < activeStepIndex" [class.next-active]="i+1 === activeStepIndex" (click)="goToStep(i)">
        <div class="circle">{{ i + 1 }}</div>
        <span class="label">{{ step.label | translate }}</span>
        <span class="arrow"></span>
      </div>
    }
  </div>

  <div class="stepper-content">
    <ng-container *ngTemplateOutlet="steps[activeStepIndex].template"></ng-container>
  </div>

  <div class="stepper-actions">
    <div>
      <button class="px-5"
        [ngClass]="{'transparent-btn bordered-btn': activeStepIndex === 0, 'custom-main-btn': activeStepIndex !== 0}"
        (click)="back()" [disabled]="activeStepIndex === 0"> {{'Back' | translate}}
      </button>

            <button class="px-5" [ngClass]="{'transparent-btn bordered-btn': activeStepIndex === steps.length - 1,
                'custom-main-btn': activeStepIndex !== steps.length - 1 }" (click)="handleNext()"
        [disabled]="activeStepIndex === steps.length - 1">
        {{ (steps[activeStepIndex]?.nextLabel || 'Next') | translate }}
      </button>
    </div>

    <div>
      @for (btn of steps[activeStepIndex]?.buttons || []; track btn) {
        @if (!btn.visible || btn.visible()) {
          <button [class]="btn.class || 'custom-main-btn'" (click)="btn.action()"
            [disabled]="isButtonDisabled(btn)">
            @if (btn.loading && btn.loading()) {
              <i class="fas fa-spinner fa-spin mr-2"></i>
            }
            {{ getButtonLabel(btn) | translate }}
          </button>
        }
      }
    </div>
  </div>
</div>